module.exports = __webpack_public_path__ + "assets/images/figurine_gerry.e86bf52.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/figurines/figurine_gerry.png
// module id = 351
// module chunks = 1